import React from "react";
import plumbing_img from "../../Images/plumbing.png";
import { useEffect } from "react";
const Plumbing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto font-Poppins py-12">
        <div className="flex flex-col lg:flex-row justify-between gap-6 lg:gap-2 items-center">
          <div className="w-full lg:w-[48%]">
            <h2 className="text-2xl lg:text-4xl font-semibold py-4">
              Plumbing Services
            </h2>
            <p className="text-lg py-4">
              PMC offers unsurpassed plumbing expertise at affordable prices.
              Our service offering covers general household plumbing,
              maintenance, drain cleaning, leak detection, off-the-grid plumbing
              solutions, and complex construction plumbing.
            </p>
            <p className="py-4">
              PMC Limited Plumbing has a maintenance division that covers all
              plumbing services. Our maintenance team all have extensive
              plumbing knowledge and has the latest plumbing technology, with
              well-stocked vehicles to ensure our clients receive the best
              possible outcome whether it be a residential home or business
              regardless of its severity or size.
            </p>
          </div>
          <div className="w-full lg:w-[48%]">
            <img src={plumbing_img} alt="" className="w-full rounded-md" />
          </div>
        </div>

        <p className="py-8">
          Plumbing repairs covers a vast spectrum in the plumbing industry so
          whether it’s a leaking tap washer or a toilet seat replacement, burst
          water pipes or a new geyser, a new basin or maybe a faulty shower rose
          or pressure control valve, our plumbers are trained to deal with the
          plumbing repair that they are faced with.
        </p>
      </div>
    </div>
  );
};

export default Plumbing;
